import { FaustTemplate, useFaustQuery } from "@faustwp/core";
import {
  CantUnhearIt as SonicConnections,
  Container,
  Title,
  Feature,
  SectionHeader,
  SEO,
  GridInductees,
  NextUpStory,
  SoundPopup,
} from "@components";
import { GetNextUpPostQuery, GetPostQuery } from "@graphqlTypes";
import RecentPosts from "@/queries/RecentPosts";
import { PostQuery } from "@/queries/Posts";
import { NextUpQuery } from "@/queries/Posts/NextUp";
import { usePageHighlight } from "@/providers/PageHighlightContext";
import { HIGHLIGHT_COLORS } from "@/core/constants";
import { useEffect } from "react";
import { getBasicQueryVars } from "@/core/utils";
import { usePageLoading } from "@/providers/LoadingContext";
import { useTrackRouteChange } from "@/providers/TrackingContext";

const Single: FaustTemplate<any> = ({ loading, pageWrapperData }: FaustPageProps<any>) => {
  const { setHighlightColor } = usePageHighlight();
  const { previewLoading, setPreviewLoading } = usePageLoading();
  const postData = useFaustQuery<GetPostQuery>(PostQuery);
  const nextUpData = useFaustQuery<GetNextUpPostQuery>(NextUpQuery);
  const {
    pageData: {
      ogTitle,
      ogDescription,
      featuredImage,
      pageCategory,
    } = {},
    featureData: { sonicConnections } = {},
    title,
  } = postData?.rhPost || {};
  const { includeFeature, feature, gridInductees } = sonicConnections || {};
  const { nextUpStory } = nextUpData || {};
  const [category] = pageCategory || [];

  useEffect(() => {
    setHighlightColor(HIGHLIGHT_COLORS.PINK);
  }, [category]);
  useTrackRouteChange(category?.slug);
  useEffect(() => {
    if (!loading && previewLoading) setPreviewLoading(false);
  }, [loading, previewLoading]);

  if (loading) return;

  return (
    <>
      <SEO title={ogTitle} description={ogDescription} image={featuredImage} />
      {sonicConnections?.headline ? (
        <>
          <SonicConnections {...sonicConnections} />
          { nextUpStory && <NextUpStory {...nextUpStory} /> }
          {includeFeature && (
            <>
              {feature?.headline && <Title headline={feature.headline} />}
              {feature?.items && <Feature items={feature.items} float={false} />    }
            </>
          )}
          { gridInductees?.headline && (
              <GridInductees
                headline={gridInductees?.headline}
                cta={gridInductees?.cta}
                inductees={gridInductees?.featuredInductees?.nodes}
              />
            )
          }
          <SoundPopup />
        </>
      ) : (
        <Container>
          <SectionHeader
            headline={title}
            subhead="FPO ONLY: No data entered for sonic connections."
          />
        </Container>
      )}
    </>
  );
};

Single.queries = [
  {
    query: PostQuery,
    variables: getBasicQueryVars,
  },
  {
    query: NextUpQuery,
    variables: ({ databaseId }) => ({ databaseId }),
  },
  {
    query: RecentPosts,
  },
];

export default Single;
